import React from 'react';
export function Disclaimer() {
  return <section className="w-full px-4 py-16 bg-ivory border-t border-taupe/10" data-id="element-20">
      <div className="max-w-4xl mx-auto text-sm text-ink/70 space-y-8" data-id="element-21">
        <h2 className="text-xl font-serif text-ink mb-6" data-id="element-22">
          Responsabilidad y condiciones de uso
        </h2>

        <div className="space-y-6" data-id="element-23">
          <div data-id="element-24">
            <h3 className="font-bold text-ink mb-2" data-id="element-25">
              Descargo de responsabilidad médica
            </h3>
            <p data-id="element-26">
              El contenido de esta guía es puramente educativo e informativo. No
              sustituye en ningún caso el diagnóstico, tratamiento ni consejo
              médico profesional. Consulta siempre con tu profesional de la
              salud antes de realizar cambios significativos en tu dieta o
              estilo de vida. Los resultados pueden variar de una persona a otra
              ya que cada cuerpo es diferente.
            </p>
          </div>

          <div data-id="element-27">
            <h3 className="font-bold text-ink mb-2" data-id="element-28">Naturaleza del producto</h3>
            <p data-id="element-29">
              Este es un producto 100% digital. No se realizará ningún envío
              físico. Recibirás acceso digital inmediato tras completar la
              compra.
            </p>
          </div>

          <div data-id="element-30">
            <h3 className="font-bold text-ink mb-2" data-id="element-31">Política de devolución</h3>
            <p data-id="element-32">
              Ofrecemos una garantía de devolución de hasta 7 días desde la
              fecha de compra, siguiendo las condiciones indicadas en nuestra
              política de reembolso.
            </p>
          </div>

          <div data-id="element-33">
            <h3 className="font-bold text-ink mb-2" data-id="element-34">
              Licencia de uso personal
            </h3>
            <p data-id="element-35">
              El contenido adquirido es para uso estrictamente individual y
              personal. No está permitida la reventa, redistribución, copia o
              reproducción parcial o total del material.
            </p>
          </div>

          <div data-id="element-36">
            <h3 className="font-bold text-ink mb-2" data-id="element-37">Propiedad intelectual</h3>
            <p data-id="element-38">
              Todos los textos, recetas, plantillas, metodologías y diseños
              incluidos en la guía están protegidos por derechos de autor.
            </p>
          </div>

          <div data-id="element-39">
            <h3 className="font-bold text-ink mb-2" data-id="element-40">Uso responsable</h3>
            <p data-id="element-41">
              El contenido debe aplicarse con sentido común y criterio propio.
              En caso de padecer condiciones de salud preexistentes, se
              recomienda encarecidamente la supervisión de un profesional
              cualificado.
            </p>
          </div>
        </div>
      </div>
    </section>;
}